var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"pros-list"},_vm._l((_vm.pros),function(pro,index){return _c('li',{key:index},[_vm._v("\n        "+_vm._s(pro.pro)+"\n    ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }